export const PUBLIC_COMMUNITY = 'PublicCommunity';
export const OPEN_COMMUNITY = 'Community';
export const GLOBAL_COMMUNITY = 'GlobalCommunity';
export const PROTECTED_COMMUNITY = 'ProtectedCommunity';
export const PRIVATE_COMMUNITY = 'PrivateCommunity';

export const config = [
  {
    communityTypes: [PUBLIC_COMMUNITY, OPEN_COMMUNITY, GLOBAL_COMMUNITY],
    messageKey: 'mentioningPublicCommunity',
    // TODO: Eventually passing a community ID
    // for a public community will search
    // everyone in the company, but this isn't deployed yet.
    // When it is the different params
    // for different community types can be removed
    generateParams: (communityId, isMultipleCommunityPosting) =>
      isMultipleCommunityPosting
        ? {
            community_id: communityId
          }
        : {}
  },
  {
    communityTypes: [PROTECTED_COMMUNITY],
    messageKey: 'protectedCommunity',
    generateParams: (communityId) => ({
      community_id: communityId
    })
  },
  {
    communityTypes: [PRIVATE_COMMUNITY],
    messageKey: 'mentioningPrivateCommunity',
    generateParams: (communityId) => ({
      community_id: communityId
    })
  }
];

export const getMenuMessageKey = (communityType) => {
  const { messageKey } =
    config.find(({ communityTypes }) =>
      communityTypes.includes(communityType)
    ) || {};
  return messageKey;
};
